import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Order} from '../../../../back-office/Models/Order';
import {environment} from '../../../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgForm} from '@angular/forms';
import {throwError} from 'rxjs';
import {OrderItemProductFabricCollection} from '../../../../back-office/Models/OrderItemProductFabricCollection';
import {Option} from '../../../../back-office/Models/Option';
import { OrderService } from 'src/app/dealer-system/Services/order.service';
import { BackOfficeOrderService } from 'src/app/back-office/Services/order.service';

@Component({
  selector: 'app-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.scss']
})
export class BackofficeViewQuoteComponent implements OnInit {
  public quoteId: number;
  public quote: Order = new Order();
  public options = [];
  public priceItem = true;
  public customerPrice = true;
  public dealerPassword: string;
  public priceItemHasError = false;
  public baseURL = environment.absolutePath;
  public baseUrl = environment.apiUrl;
  public optionType: Option;

  @ViewChild('passwordModal', {static: false}) passwordModal = null;
  @ViewChild('passwordModalForm', {static: false}) passwordModalForm: NgForm;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly orderService: OrderService,
    private readonly orderBackofficeService: BackOfficeOrderService,
    private readonly helper: Helper,
    private readonly translate: TranslateService,
    private readonly auth: AuthenticationService,
    private readonly router: Router
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.quoteId = params['id'];
        this.orderService.getQuoteOrder(this.quoteId).subscribe((resp) => {
          this.quote = resp;
          this.orderService.getQuoteOption(this.quoteId).subscribe(option => {
            this.quote.orderItems.forEach((orderItem) => {
              const orderItemId = orderItem.id;
              if (option[orderItemId] == null) {
                this.options.push([]);
              } else {
                this.options.push(Object.values(option[orderItemId]));
              }

            });
          });
        });
      }
    });

  }

  orderItemCount(index) {
    return parseInt(index) + 1;
  }

  public catchError(response) {
    const body: any = response.error;
    this.helper.popMessageDialog(this.translate.instant('auth.password_is_invalid'), this.translate.instant('auth.password_is_invalid'));
    this.priceItemHasError = true;
    this.passwordModalForm.reset();
    return throwError(body.errors);
  }
  getQuotePdf() {
    const kind = (this.customerPrice) ? 'customer' : 'dealer';
    this.orderService.getPdf(this.quoteId, kind).subscribe();
  }

  EditOrder() {
    this.router.navigateByUrl('back-office/quote/' + this.quoteId + '/edit');
  }

  getDealerPrice(event) {
    this.customerPrice = !!event;
  }

  getCustomerPrice() {
    this.auth.checkPassword(this.dealerPassword).pipe(catchError(res => this.catchError(res))).subscribe(() => {
      this.passwordModal.hide();
      this.customerPrice = false;
      this.dealerPassword = null;
      this.passwordModalForm.reset();
    });
  }

  checkPasswordError() {
    if (this.priceItemHasError || !Helper.isDefined(this.dealerPassword) || (!this.priceItemHasError || Helper.isDefined(this.dealerPassword))) {
      this.priceItem = true;
    }
    this.passwordModal.hide();
  }

  checkChildOption(optionItem) {
    const children = [];
    this.quote.orderItems.forEach(res => {
      res.orderItemOptions.forEach(orderItemOption => {
        if (orderItemOption.parent && orderItemOption.parent['id'] == optionItem) {
          children.push(orderItemOption);
        }
      });

    });

  }

  checkHasChild(optionItem) {
    this.quote.orderItems.forEach(res => {
      res.orderItemOptions.forEach(orderItemOption => {
        if (orderItemOption.parent && orderItemOption.parent['id'] == optionItem) {
          return true;
        }
      });
    });
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null);
  }
}
